var _defs, _rect, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteMultiroomAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Work",
    "data-name": "Line Work",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4_WWW_Icons_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.45,
    y: 23.49,
    width: 33.08,
    height: 57.4,
    rx: 4.68
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.9,
    cy: 37.79,
    r: 2.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.9,
    cy: 37.79,
    r: 8.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.9,
    cy: 62.44,
    r: 4.84
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.9,
    cy: 62.44,
    r: 12.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteMultiroomAudio);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White-Multiroom-Audio.200c5170dd3e30208db1908b805a2a65.svg";
export { ForwardRef as ReactComponent };